/*jshint esversion: 11 */
import sendApiRequest from '../helpers/axios-setup';
import { buildChildListQueryParams } from './childQueryParams';

/**
 *
 * @returns {Promise}
 */
export async function getChildList(page, limit, queryOptions = {}, sorting_option = '') {
  const params = {
    page,
    limit,
    ...buildChildListQueryParams(queryOptions, sorting_option)
  };

  try {
    const response = await sendApiRequest.get('/child', { params });
    return response.data?.data[0];
  } catch (e) {
    return null;
  }
}

function buildExportParams(queryOptions = {}, sorting_option = '') {
  return buildChildListQueryParams(queryOptions, sorting_option);
}

export async function exportChildList(queryOptions = {}, onDownloadProgress) {
  try {
    const response = await sendApiRequest.get('/child/export', {
      params: buildExportParams(queryOptions, queryOptions.sorting_option),
      onDownloadProgress: (progressEvent) => {
        if (onDownloadProgress && progressEvent.total) {
          const percent = Math.round(
            (progressEvent.loaded * 70) / progressEvent.total
          );
          onDownloadProgress(Math.min(70, Math.max(10, percent)));
        } else if (onDownloadProgress) {
          onDownloadProgress(30);
        }
      }
    });
    const payload = response.data?.data;
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.data)) return payload.data;
    return [];
  } catch (e) {
    throw e?.response?.data?.error || e?.message || 'Export failed';
  }
}

/**
 *
 * @param {String} name
 * @param {String} email_address
 * @param {String} password
 * @param {String} phone_number
 * @param {Date} dob
 * @param {String} gender
 * @param {String} address
 * @param {String} address_location
 * @param {Array} parents
 * @param {String} mother_tongue
 * @param {Array} languages_spoken
 * @param {String} blood_group
 * @param {String} allergies
 * @param {String} good_habits
 * @param {String} bad_habits
 * @param {String} sleeping_pattern
 * @returns {Promise<Object>}
 */
export async function addNewChild(data) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.post('/child', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

/**
 *
 * @param {String} childId
 * @returns
 */
export async function getChildInfo(childId) {
  try {
    const response = await sendApiRequest.get(`/child/${childId}`);
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

/**
 *
 * @param {String} childId
 * @param {String} name
 * @param {String} email_address
 * @param {String} password
 * @param {String} phone_number
 * @param {Date} dob
 * @param {String} gender
 * @param {String} address
 * @param {String} address_location
 * @param {Array} parents
 * @param {String} mother_tongue
 * @param {Array} languages_spoken
 * @param {String} blood_group
 * @param {String} allergies
 * @param {String} good_habits
 * @param {String} bad_habits
 * @param {String} sleeping_pattern
 * @returns {Promise<Object>}
 */
export async function updateChild(childId, data) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.put(`/child/${childId}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

/**
 *
 * @param {String} childId
 * @returns
 */
export async function getGalleryImages(childId, params) {
  try {
    const response = await sendApiRequest.get(`/child/gallery/${childId}`, {
      params
    });
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

/**
 *
 * @param {String} childId
 * @returns
 */
export async function deleteRestoreChild(childId, type) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.delete(`/child/${childId}`, {
      params: {
        type: type
      }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

/**
 *
 * @param {String} childId
 * @param {String} imageId
 * @returns
 */
export async function deleteImageFromExecution(execution_id, image_id) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.delete(
      `/execution/${execution_id}/image/${image_id}`
    );
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

export async function sendEmail(child_id) {
  try {
    const response = await sendApiRequest.post(
      `/child/profile/email/${child_id}`
    );
    return { response: response.data, error: null };
  } catch (e) {
    const message = e?.response?.data?.message || e.message || 'Unknown error';
    return { response: null, error: message };
  }
}


export async function createSurveyFromChild(child_id) {
  try {
    const response = await sendApiRequest.post(
      `/child/survey/${child_id}`
    );
    return { response: response.data, error: null };
  } catch (e) {
    console.log(e);
    const message = e?.response?.data?.message || e.message || 'Unknown error';
    return { response: null, error: message };
  }
}
